/* ==========================================================================
   YOYA — storefront JS for Shopify (vanilla, no dependencies)
   Reads window.YOYA (set in layout/theme.liquid). Talks to Shopify's cart
   endpoints; everything is event-delegated so the theme editor can re-render
   sections without losing behaviour.
   ========================================================================== */
(function () {
  "use strict";
  const C = window.YOYA || {};
  const S = C.strings || {};
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  /* ------------------------------------------------------------ money */
  function money(cents) {
    const fmt = C.moneyFormat || "${{amount}}";
    const n = (Number(cents) || 0) / 100;
    const two = n.toFixed(2), whole = Math.round(n).toString();
    const comma = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const map = {
      amount: comma(two),
      amount_no_decimals: comma(whole),
      amount_with_comma_separator: two.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."),
      amount_no_decimals_with_comma_separator: whole.replace(/\B(?=(\d{3})+(?!\d))/g, "."),
      amount_with_apostrophe_separator: two.replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
      amount_no_decimals_with_space_separator: whole.replace(/\B(?=(\d{3})+(?!\d))/g, " "),
      amount_with_space_separator: two.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k in map ? map[k] : map.amount)).replace(/<[^>]+>/g, "");
  }
  const ART = {
    set:'<path d="M22 8h36l6 12-9 4-3-5v20H28V19l-3 5-9-4z"/><path d="M28 44h24l4 44H46l-2-30h-4l-2 30H24z"/>',
    bottom:'<path d="M20 6h40l4 40-4 46H42l-2-52h-0l-2 52H20l-4-46z"/><path d="M20 20h40"/>',
    top:'<path d="M26 8h28l14 10-7 11-5-3v40H24V26l-5 3-7-11z"/><path d="M32 8c0 6 3.6 9 8 9s8-3 8-9"/>',
    dress:'<path d="M28 6h24l8 9-7 8 13 55c-9 5-33 5-42 0l13-55-7-8z"/><path d="M34 6c0 5 2.7 8 6 8s6-3 6-8"/>',
    acc:'<path d="M14 26h52l-5 56H19z"/><path d="M28 26V17a12 12 0 0 1 24 0v9"/>'
  };
  const kindOf = (t) => { t = String(t || "").toLowerCase(); return /set|lounge/.test(t) ? "set" : /legging|short|pant/.test(t) ? "bottom" : /dress|skirt/.test(t) ? "dress" : /bag|tote|acc/.test(t) ? "acc" : "top"; };
  const thumb = (img, alt, type) => img
    ? `<img src="${esc(img)}" alt="${esc(alt)}" loading="lazy">`
    : `<div class="ph ph--${kindOf(type)}" aria-hidden="true"><svg viewBox="0 0 80 100">${ART[kindOf(type)]}</svg></div>`;

  /* ------------------------------------------------------------ toast */
  function toast(msg) {
    let host = $(".toasts");
    if (!host) { host = document.createElement("div"); host.className = "toasts"; host.setAttribute("aria-live", "polite"); document.body.appendChild(host); }
    const el = document.createElement("div");
    el.className = "toast";
    el.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg><span>${esc(msg)}</span>`;
    host.appendChild(el);
    setTimeout(() => { el.classList.add("out"); setTimeout(() => el.remove(), 220); }, 3200);
  }

  /* ------------------------------------------------------------- cart */
  let cart = null;
  const jsonFetch = (url, opts) => fetch(url, Object.assign({ headers: { "Content-Type": "application/json", "Accept": "application/json" } }, opts || {})).then(r => {
    if (!r.ok) return r.json().then(j => { throw new Error(j.description || j.message || "Cart error"); });
    return r.json();
  });
  const loadCart = () => jsonFetch(C.routes.cartFetch).then(c => { cart = c; paintCart(); return c; });

  /* the drawer opens on the tap itself and shows a busy line while the server
     catches up, so adding never feels like nothing happened */
  function setBusy(on) { const d = $("#cartDrawer"); if (d) d.classList.toggle("is-busy", on); }
  /* a card quick add only peeks the bag: it glides in beside the page (no
     dimming, no scroll lock, focus stays put), shows what was added, then
     glides back out. Touching or scrolling inside it keeps it open until the
     shopper closes it or taps back on the page. */
  let peekTimer = 0, peekOutside = null, peekState = null;
  const isPeeking = (d) => d && d.classList.contains("is-peek") && d.classList.contains("on");
  const HOLD_EVENTS = ["pointerdown", "wheel", "touchstart", "keydown"];
  function peekDisarm(d) {
    clearTimeout(peekTimer);
    if (peekOutside) { document.removeEventListener("pointerdown", peekOutside, true); peekOutside = null; }
    if (peekState) {
      d.removeEventListener("pointermove", peekState.move); d.removeEventListener("pointerleave", peekState.leave);
      HOLD_EVENTS.forEach(ev => d.removeEventListener(ev, peekState.hold));
      peekState = null;
    }
  }
  function peekSchedule(d, ms) {
    clearTimeout(peekTimer);
    peekTimer = setTimeout(() => { const st = peekState; if (st && !st.held && !st.hover && isPeeking(d)) peekClose(d); }, ms);
  }
  /* reading it (moving the mouse over it) pauses the timer and leaving
     restarts it; a tap, scroll or key inside keeps it open until closed or
     until the shopper taps back on the page. A mouse resting where the bag
     happens to slide in doesn't count. */
  function peekArm(d) {
    if (peekState) { peekState.t0 = Date.now(); return peekState; }
    const st = peekState = { held: false, hover: false, ready: false, t0: Date.now() };
    st.move = (e) => { if (st.held || Date.now() - st.t0 < 700 || !(e.movementX || e.movementY)) return; if (!st.hover) { st.hover = true; clearTimeout(peekTimer); } };
    st.leave = () => { if (!st.hover) return; st.hover = false; if (!st.held && st.ready) peekSchedule(d, 1200); };
    st.hold = (e) => {
      if (st.held || Date.now() - st.t0 < 300) return;
      if (e.type === "keydown" && e.key === "Escape") { peekClose(d); return; }
      st.held = true; clearTimeout(peekTimer);
      peekOutside = (ev) => { if (!d.contains(ev.target)) peekClose(d); };
      document.addEventListener("pointerdown", peekOutside, true);
    };
    d.addEventListener("pointermove", st.move, { passive: true }); d.addEventListener("pointerleave", st.leave);
    HOLD_EVENTS.forEach(ev => d.addEventListener(ev, st.hold, { passive: true }));
    return st;
  }
  function peekOpen(d) {
    if (!cart) loadCart(); else paintCart();
    if (isPeeking(d)) return;
    d.classList.add("is-peek"); d.hidden = false;
    d.getBoundingClientRect(); /* commit the off-screen start so the slide eases in */
    d.classList.add("on");
  }
  function peekClose(d) {
    peekDisarm(d);
    d.classList.remove("on");
    setTimeout(() => { if (!d.classList.contains("on")) { d.hidden = true; d.classList.remove("is-peek"); } }, 600);
  }
  function closeCart(d) { if (!d) return; if (d.classList.contains("is-peek")) peekClose(d); else closeLayer(d); }
  function addToCart(variantId, qty, label, peek) {
    const d = $("#cartDrawer");
    const fullOpen = d && !d.hidden && d.classList.contains("on") && !d.classList.contains("is-peek");
    const peeking = !!(peek && d && !fullOpen);
    clearTimeout(peekTimer);
    let st = null;
    if (peeking) { peekOpen(d); st = peekArm(d); st.ready = false; }
    else openDrawer();
    setBusy(true);
    return jsonFetch(C.routes.cartAdd + ".js", { method: "POST", body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }) })
      .then(() => loadCart())
      .then(() => { if (!peeking) toast((label ? label + " " : "") + (S.added || "added to bag")); })
      .catch(e => toast(e.message))
      .finally(() => {
        setBusy(false);
        if (st && st === peekState) { st.ready = true; if (!st.held && !st.hover) peekSchedule(d, 2600); }
      });
  }
  /* quantity changes paint straight away from the cart we already have; rapid
     taps on +/- collapse into one request per line, and the server's answer
     replaces the guess when it lands */
  const pendingQty = {}, qtyTimers = {};
  function changeLine(key, qty) {
    qty = Math.max(0, qty);
    if (cart) {
      const line = cart.items.find(i => i.key === key);
      if (line) {
        const delta = qty - line.quantity, unit = line.quantity ? line.final_line_price / line.quantity : line.final_price;
        cart.item_count += delta;
        cart.total_price += Math.round(unit * delta);
        cart.items_subtotal_price += Math.round(unit * delta);
        line.quantity = qty; line.final_line_price = Math.round(unit * qty);
        if (qty === 0) cart.items = cart.items.filter(i => i !== line);
        paintCart();
      }
    }
    pendingQty[key] = qty;
    clearTimeout(qtyTimers[key]);
    return new Promise(res => {
      qtyTimers[key] = setTimeout(() => {
        const q = pendingQty[key]; delete pendingQty[key];
        jsonFetch(C.routes.cartChange + ".js", { method: "POST", body: JSON.stringify({ id: key, quantity: q }) })
          .then(c => { if (!Object.keys(pendingQty).length) { cart = c; paintCart(); } if (q === 0) toast(S.removed || "Removed"); })
          .catch(e => { toast(e.message); loadCart(); })
          .finally(res);
      }, 220);
    });
  }

  function paintCart() {
    if (!cart) return;
    const units = cart.item_count;
    $$(".cart-count").forEach(el => { el.textContent = units; el.hidden = units === 0; });
    $$("[data-cart-units]").forEach(el => { el.textContent = units; });

    const body = $("#cartItems"); if (!body) return;
    const total = cart.total_price;

    if (!cart.items.length) {
      body.innerHTML = `<div class="d-empty"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>
        <p>${esc(S.empty)}</p><a class="btn btn-ink" href="${esc(C.routes.all)}">${esc(S.shop)}</a></div>`;
    } else {
      body.innerHTML = cart.items.map(i => `<article class="ci">
        <a class="ci-m" href="${esc(i.url)}" aria-label="${esc(i.product_title)}">${thumb(i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : null, i.product_title, i.product_type)}</a>
        <div class="ci-b">
          <a class="n" href="${esc(i.url)}">${esc(i.product_title)}</a>
          ${i.variant_title && i.variant_title !== "Default Title" ? `<span class="v">${esc(i.variant_title)}</span>` : ""}
          <span class="p num">${money(i.final_line_price)}</span>
          <div class="ci-f">
            <div class="qty">
              <button type="button" data-dec="${esc(i.key)}" data-q="${i.quantity}" aria-label="Decrease quantity">&minus;</button>
              <span class="v num">${i.quantity}</span>
              <button type="button" data-inc="${esc(i.key)}" data-q="${i.quantity}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="ci-rm" data-rm="${esc(i.key)}">${esc(S.remove)}</button>
          </div>
        </div></article>`).join("");
    }

    const bar = $("#shipBar");
    if (bar) {
      if (!C.freeShipOver || !cart.items.length) bar.hidden = true;
      else {
        bar.hidden = false;
        const remain = Math.max(0, C.freeShipOver - total), pct = Math.min(100, total / C.freeShipOver * 100);
        bar.innerHTML = `<div class="t"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 7h11v9H2zM13 11h4.5l3 3v2H13z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>${
          remain === 0 ? `<span><b>${esc(S.freeUnlocked)}</b></span>` : `<span>${esc(S.freeRemaining).replace("__AMT__", `<b class="num">${money(remain)}</b>`)}</span>`
        }</div><div class="track"><div class="fill" style="width:${pct.toFixed(1)}%"></div></div>`;
      }
    }

    const foot = $("#cartFoot");
    if (foot) {
      foot.hidden = !cart.items.length;
      const free = C.freeShipOver && total >= C.freeShipOver;
      $("#cartSums").innerHTML = `
        <div class="d-line"><span>${esc(S.subtotal)}</span><span class="num">${money(cart.items_subtotal_price)}</span></div>
        <div class="d-line"><span>${esc(S.shipping)}</span><span>${free ? esc(S.shipFree) : esc(S.shipCheckout)}</span></div>
        <div class="d-line tot"><span>${esc(S.total)}</span><span class="num">${money(total)}</span></div>`;
    }

    const sb = $("#stickyBar");
    if (sb && sb.dataset.mode === "cart") $(".info", sb).innerHTML = `<b>${units} item${units === 1 ? "" : "s"} in bag</b><span class="num">${money(total)}</span>`;
  }

  /* -------------------------------------------------- layers (a11y) */
  let lastFocus = null;
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function trap(panel, e) {
    if (e.key !== "Tab") return;
    const f = $$(FOCUSABLE, panel).filter(el => el.offsetParent !== null); if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openLayer(panel, onKey) {
    const scrim = $("#scrim"); lastFocus = document.activeElement;
    if (scrim) scrim.hidden = false; panel.hidden = false;
    requestAnimationFrame(() => { if (scrim) scrim.classList.add("on"); panel.classList.add("on"); });
    document.body.style.overflow = "hidden";
    const f = $$(FOCUSABLE, panel).filter(el => el.offsetParent !== null)[0]; if (f) f.focus();
    panel._key = onKey; document.addEventListener("keydown", onKey);
  }
  function closeLayer(panel) {
    const scrim = $("#scrim");
    panel.classList.remove("on"); if (scrim) scrim.classList.remove("on");
    document.body.style.overflow = "";
    if (panel._key) document.removeEventListener("keydown", panel._key);
    setTimeout(() => { if (!panel.classList.contains("on")) panel.hidden = true; if (scrim && !scrim.classList.contains("on")) scrim.hidden = true; }, 560);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openDrawer() {
    const d = $("#cartDrawer"); if (!d) return;
    if (!cart) loadCart(); else paintCart();
    if (d.classList.contains("is-peek")) { peekDisarm(d); d.classList.remove("is-peek"); }
    else if (!d.hidden && d.classList.contains("on")) return; /* already open */
    openLayer(d, (e) => { if (e.key === "Escape") closeLayer(d); trap(d, e); });
  }
  function openMobileNav() {
    const m = $("#mnav"), b = $("#burger"); if (!m) return;
    openLayer(m, (e) => { if (e.key === "Escape") closeMobileNav(); trap(m, e); });
    m.classList.add("open"); if (b) b.setAttribute("aria-expanded", "true");
  }
  function closeMobileNav() {
    const m = $("#mnav"), b = $("#burger"); if (!m) return;
    m.classList.remove("open"); if (b) b.setAttribute("aria-expanded", "false"); closeLayer(m);
  }

  /* ------------------------------------------------------ mega menu */
  let megaT = null;
  function setMega(target) {
    $$(".nav-item[data-mega]").forEach(it => {
      const on = it === target; it.classList.toggle("open", on);
      const a = $("a", it); if (a) a.setAttribute("aria-expanded", String(on));
    });
  }
  document.addEventListener("mouseover", (e) => { const it = e.target.closest(".nav-item[data-mega]"); if (it) { clearTimeout(megaT); setMega(it); } });
  document.addEventListener("mouseout", (e) => { const it = e.target.closest(".nav-item[data-mega]"); if (it && !it.contains(e.relatedTarget)) megaT = setTimeout(() => setMega(null), 140); });
  document.addEventListener("focusin", (e) => { const it = e.target.closest(".nav-item[data-mega]"); setMega(it || null); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") setMega(null); });

  /* --------------------------------------------------- announcement */
  function initAnnouncement() {
    const host = $("#annRot"); if (!host || host._on) return; host._on = true;
    const nodes = $$(".ann-msg", host); if (nodes.length < 2) return;
    let i = 0; setInterval(() => { nodes[i].classList.remove("on"); i = (i + 1) % nodes.length; nodes[i].classList.add("on"); }, Number(host.dataset.rotate) || 5200);
  }

  /* ------------------------------------------------------- variants */
  function readVariants(root) { const el = $("[data-variants]", root); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }

  /* product page */
  function initPDP() {
    const root = $("[data-product]"); if (!root || root._on) return; root._on = true;
    const vs = readVariants(root), form = $("#pdpForm", root), idInput = $("[data-variant-id]", root);
    const optGroups = $$(".opt[data-option-index]", root);
    const sel = () => optGroups.map(g => { const b = $('[aria-pressed="true"]', g); return b ? b.dataset.value : null; });
    const match = () => { const s = sel(); return vs.find(v => s.every((val, i) => val == null || v["option" + (i + 1)] === val)); };
    const exact = () => { const s = sel(); return vs.find(v => s.every((val, i) => v["option" + (i + 1)] === val)); };

    /* Show only the photos for the current choices. Cells carry a colour tag
       ("|blue") and a tag per other option ("|1=brashorts;"), both read from
       alt text/filename in Liquid. Size never filters. Untagged cells are
       shared and always shown; a choice with no photos of its own stops
       filtering instead of emptying the grid. Mirrors the first paint. */
    const norm = (v) => String(v || "").toLowerCase().replace(/[-_ .+&,]/g, "");
    const ci = optGroups.findIndex(g => /colo|farbe|couleur/i.test($(".lb", g) ? $(".lb", g).textContent : ""));
    const isSize = (g) => /^\s*sizes?\s*:/i.test($(".lb", g) ? $(".lb", g).textContent : "");
    function galleryFor(s) {
      const cells = $$("#galGrid .gal-cell"); if (!cells.length) return { cells, shown: [] };
      const want = ci > -1 && s[ci] ? s[ci].toLowerCase() : "";
      const anyColour = want && cells.some(c => (c.dataset.colours || "").includes("|" + want));
      let base = cells.filter(c => { const t = (c.dataset.colours || "").trim(); return !anyColour || !t || t === "|" + want; });
      const opts = optGroups.map((g, gi) => (gi === ci || isSize(g) || s[gi] == null) ? null : [gi, norm(s[gi])]).filter(Boolean);
      const optOK = (c) => opts.every(([gi, v]) => { const o = c.dataset.opts || ""; return !o.includes("|" + gi + "=") || o.includes("|" + gi + "=" + v + ";"); });
      const full = base.filter(optOK);
      const shown = full.some(c => c.dataset.opts) ? full : base;
      return { cells, shown };
    }
    function filterGallery() {
      const { cells, shown } = galleryFor(sel()); if (!cells.length) return;
      cells.forEach(c => {
        const on = shown.includes(c);
        c.hidden = !on;
        /* an untagged upload is shared, so it must never outrank this choice's
           own photos — push it to the end instead of letting it lead */
        c.style.order = ((c.dataset.colours || "").trim() || c.dataset.opts) ? "0" : "1";
      });
      const firstVisible = cells.filter(c => !c.hidden).sort((x, y) => Number(x.style.order) - Number(y.style.order))[0];
      cells.forEach(c => c.classList.toggle("is-first", c === firstVisible));
      /* photos revealed by a change load now rather than when scrolled to */
      shown.slice(0, 2).forEach(c => { const im = $("img", c); if (im) im.loading = "eager"; });
    }
    /* fallback for products whose photos aren't colour-tagged: swap the lead image */
    function showImage(src) {
      const cell = $("#galGrid .gal-cell:not([hidden]) img") || $("#galGrid img");
      if (!cell) return;
      cell.removeAttribute("srcset"); cell.removeAttribute("sizes"); cell.src = src;
    }

    function refresh() {
      const v = exact(), btn = $("#pdpAdd", root), lbl = $("[data-add-label]", root);
      const priceNow = $("[data-price-now]", root), sticky = $("[data-sticky-price]");
      /* the gallery follows the chosen colour on its own: waiting for a complete
         variant meant picking a colour did nothing until a size was also chosen,
         and nothing at all for a colour/size pair that doesn't exist */
      const tagged = $$("#galGrid .gal-cell").some(c => (c.dataset.colours || "").trim() !== "" || c.dataset.opts);
      if (tagged) filterGallery();

      if (v) {
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        if (sticky) sticky.textContent = money(v.price);
        btn.disabled = !v.available;
        lbl.textContent = v.available ? `${S.add} — ${money(v.price)}` : S.soldOut;
        if (!tagged && v.featured_image && v.featured_image.src) showImage(v.featured_image.src);
        if (history.replaceState) { const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u); }
      }
      /* grey out option values that have no available variant given the other selections */
      optGroups.forEach((g, gi) => {
        $$(".size,.sw", g).forEach(b => {
          const s = sel(); s[gi] = b.dataset.value;
          const ok = vs.some(v => v.available && s.every((val, i) => val == null || v["option" + (i + 1)] === val));
          if (b.classList.contains("size")) b.disabled = !ok; else b.dataset.soldout = ok ? "" : "1";
        });
      });
    }

    /* hovering (desktop) or touching (phone) a colour/set starts its photos
       downloading, so they're ready by the time the tap lands */
    const warmChoice = (e) => {
      const b = e.target.closest && e.target.closest(".opt .size, .opt .sw"); if (!b || b.disabled) return;
      const g = b.closest(".opt"), gi = optGroups.indexOf(g); if (gi < 0 || isSize(g)) return;
      const s = sel(); s[gi] = b.dataset.value;
      galleryFor(s).shown.forEach(c => { const im = $("img", c); if (im && im.loading !== "eager") im.loading = "eager"; });
    };
    root.addEventListener("pointerover", warmChoice, { passive: true });
    root.addEventListener("pointerdown", warmChoice, { passive: true });

    root.addEventListener("click", (e) => {
      const b = e.target.closest(".opt .size, .opt .sw"); if (!b || b.disabled) return;
      const g = b.closest(".opt");
      $$(".size,.sw", g).forEach(x => x.setAttribute("aria-pressed", "false"));
      b.setAttribute("aria-pressed", "true");
      const lab = $("[data-option-label]", g); if (lab) lab.textContent = b.dataset.value;
      const note = $("[data-size-note]", g); if (note) note.hidden = true;
      refresh();
    });

    if (form) form.addEventListener("submit", (e) => {
      e.preventDefault();
      const missing = optGroups.find(g => !$('[aria-pressed="true"]', g));
      if (missing) { const n = $("[data-size-note]", missing); if (n) n.hidden = false; const f = $(".size:not([disabled]),.sw", missing); if (f) f.focus(); toast(S.pickSize); return; }
      const v = exact(); if (!v || !v.available) { toast(S.soldOut); return; }
      const btn = $("#pdpAdd", root); btn.classList.add("is-loading");
      const title = $("h1", root).textContent + (v.title && v.title !== "Default Title" ? " · " + v.title : "");
      addToCart(v.id, 1, title).finally(() => btn.classList.remove("is-loading"));
    });

    const stickyAdd = $("[data-sticky-add]"); if (stickyAdd && form) stickyAdd.addEventListener("click", () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true })));

    /* gallery */
    const thumbs = $(".gal-thumbs", root);
    if (thumbs) thumbs.addEventListener("click", (e) => {
      const t = e.target.closest(".gal-thumb"); if (!t) return;
      $$(".gal-thumb", thumbs).forEach(x => x.setAttribute("aria-selected", "false")); t.setAttribute("aria-selected", "true");
      showImage(t.dataset.full);
      const g = $("#galGrid"); if (g) g.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    /* size guide */
    const sg = $("[data-size-guide]", root), modal = $("#sizeModal");
    if (sg && modal) {
      sg.addEventListener("click", () => openLayer(modal, (e) => { if (e.key === "Escape") closeLayer(modal); trap(modal, e); }));
      $$("[data-close-modal]", modal).forEach(b => b.addEventListener("click", () => closeLayer(modal)));
    }

    refresh();
  }

  /* ------------------------------------------------- sticky mobile bar */
  function initSticky() {
    const bar = $("#stickyBar"); if (!bar || bar._on) return; bar._on = true;
    document.body.classList.add("has-sticky");
    const anchor = $("[data-shop-anchor]") || $(".pdp");
    let raf = null;
    const show = () => bar.classList.toggle("on", window.scrollY > (anchor ? anchor.offsetTop - 300 : 500));
    window.addEventListener("scroll", () => { if (raf) return; raf = requestAnimationFrame(() => { show(); raf = null; }); }, { passive: true });
    show();
  }

  /* ------------------------------------------------ address selectors */
  function initAddress() {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) return;
    $$("[data-address-country]").forEach(c => {
      if (c._on) return; c._on = true;
      const p = c.closest("form").querySelector("[data-address-province]");
      new Shopify.CountryProvinceSelector(c.id, p.id, { hideElement: p.closest(".field").id || p.id });
    });
  }

  /* ------------------------------------------------------- reviews */
  function openReviews() {
    const sec = document.getElementById("reviews"); if (!sec) return false;
    sec.hidden = false;
    sec.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }

  /* desktop: an open quick-add row folds back when the mouse leaves its card */
  document.addEventListener("mouseout", (e) => {
    const c = e.target.closest && e.target.closest(".card.is-qa");
    if (c && !c.contains(e.relatedTarget)) c.classList.remove("is-qa");
  });

  /* -------------------------------------------- card colour swatches
     Each colour's photo is fetched before it's tapped, with the same srcset
     and sizes as the card photo so the browser picks the exact file it will
     need. The tap then swaps from cache. Desktop warms a card when the
     pointer enters it; touch screens warm the cards on screen once idle. */
  const cardSizes = (card) => { const a = $(".card-media img.a", card); return (a && a.getAttribute("sizes")) || "(max-width: 760px) 50vw, 25vw"; };
  function warmSwatch(card, b) {
    if (b._img || !b.dataset.srcset) return b._img;
    const i = new Image(); i.decoding = "async"; i.sizes = cardSizes(card); i.srcset = b.dataset.srcset; i.src = b.dataset.img;
    return (b._img = i);
  }
  function warmCard(card) {
    if (!card || card._warm) return; card._warm = true;
    $$(".csw[data-srcset]", card).forEach(b => { if (b.offsetParent !== null) warmSwatch(card, b); });
  }
  function swapCardColour(card, b) {
    const a = $(".card-media img.a", card); if (!a || !b.dataset.img) return;
    card.classList.add("card--colored");
    const show = () => {
      if (b.getAttribute("aria-pressed") !== "true") return; /* a later tap won */
      a.sizes = cardSizes(card); if (b.dataset.srcset) a.srcset = b.dataset.srcset; else a.removeAttribute("srcset");
      a.src = b.dataset.img;
    };
    const pre = warmSwatch(card, b);
    /* cached: swap this frame. still loading: swap the moment it's decoded,
       so the old photo never flashes half-drawn */
    if (!pre || (pre.complete && pre.naturalWidth)) { show(); return; }
    /* decode() can stall (background tabs, some browsers), so whichever of
       decoded / loaded / 400ms comes first does the swap */
    let done = false; const once = () => { if (!done) { done = true; show(); } };
    pre.addEventListener("load", once, { once: true }); pre.addEventListener("error", once, { once: true });
    if (pre.decode) pre.decode().then(once, once);
    setTimeout(once, 400);
  }
  const saveData = navigator.connection && navigator.connection.saveData;
  document.addEventListener("mouseover", (e) => { const c = e.target.closest && e.target.closest("[data-card]"); if (c) warmCard(c); }, { passive: true });
  document.addEventListener("pointerdown", (e) => { const b = e.target.closest && e.target.closest("[data-card] .csw"); if (b) warmSwatch(b.closest("[data-card]"), b); }, { passive: true });
  function initSwatchWarmup() {
    if (saveData || !("IntersectionObserver" in window) || !matchMedia("(hover: none)").matches) return;
    const idle = window.requestIdleCallback || ((f) => setTimeout(f, 200));
    const io = new IntersectionObserver((ents) => ents.forEach(en => {
      if (!en.isIntersecting) return; io.unobserve(en.target); idle(() => warmCard(en.target));
    }), { rootMargin: "150px 0px" });
    $$("[data-card]").forEach(c => { if (!c._warm && $(".csw[data-srcset]", c)) io.observe(c); });
  }

  /* -------------------------------------------------- delegated clicks */
  document.addEventListener("click", (e) => {
    const t = e.target;
    let el;
    /* tapping away folds an open quick-add row back into its button */
    $$(".card.is-qa").forEach(c => { if (!c.contains(t)) c.classList.remove("is-qa"); });
    if ((el = t.closest("[data-open-cart]"))) { e.preventDefault(); openDrawer(); return; }
    if (t.closest("[data-close-cart]")) { closeCart($("#cartDrawer")); return; }
    if (t.closest("#scrim")) { const d = $("#cartDrawer"), m = $("#mnav"), sm = $("#sizeModal"); if (d && !d.hidden) closeCart(d); if (m && !m.hidden) closeMobileNav(); if (sm && !sm.hidden) closeLayer(sm); return; }
    if (t.closest("#burger")) { openMobileNav(); return; }
    /* product reviews stay hidden until the stars / reviews link is tapped */
    if ((el = t.closest('a[href="#reviews"]')) && openReviews()) { e.preventDefault(); return; }
    if (t.closest("#mnav [data-close]") || (t.closest("#mnav a") && !t.closest("#mnav a[aria-controls]"))) { closeMobileNav(); return; }

    if ((el = t.closest("[aria-expanded][aria-controls]")) && (el.closest("#mnav") || el.closest("[data-accordion]"))) {
      const open = el.getAttribute("aria-expanded") === "true";
      el.setAttribute("aria-expanded", String(!open));
      const p = document.getElementById(el.getAttribute("aria-controls")); if (p) p.hidden = open;
      return;
    }

    if ((el = t.closest("[data-tabs] .tab"))) {
      const tabs = el.closest("[data-tabs]");
      $$(".tab", tabs).forEach(b => { b.setAttribute("aria-selected", "false"); const p = document.getElementById(b.getAttribute("aria-controls")); if (p) p.hidden = true; });
      el.setAttribute("aria-selected", "true"); const p = document.getElementById(el.getAttribute("aria-controls")); if (p) p.hidden = false;
      return;
    }

    if ((el = t.closest("[data-card] .csw"))) {
      const card = el.closest("[data-card]");
      $$(".csw", card).forEach(b => b.setAttribute("aria-pressed", "false")); el.setAttribute("aria-pressed", "true");
      card.dataset.color = el.dataset.value;
      swapCardColour(card, el);
      return;
    }
    /* card quick add: the corner button opens the size row (or adds straight
       away when there is only one size), and a size resolves against the
       colour the shopper is currently looking at on that card. */
    if ((el = t.closest("[data-qadd]"))) {
      const card = el.closest("[data-card]"), panel = card ? $(".qadd", card) : null;
      if (panel && $$(".qadd-b", panel).length > 1) { card.classList.toggle("is-qa"); return; }
      el.classList.add("is-loading");
      const lbl = card ? ($(".ttl", card) || {}).textContent : "";
      addToCart(Number(el.dataset.qadd), 1, lbl, true).finally(() => el.classList.remove("is-loading"));
      return;
    }
    if ((el = t.closest("[data-qsize]"))) {
      const card = el.closest("[data-card]"); if (!card) return;
      let vars = []; try { vars = JSON.parse($("[data-cvars]", card).textContent); } catch (e) { return; }
      const chosen = $(".csw[aria-pressed='true']", card);
      const colour = card.dataset.color || (chosen ? chosen.dataset.value : null);
      const size = el.dataset.qsize;
      const v = vars.find(x => x.s === size && colour && x.c === colour) || vars.find(x => x.s === size);
      if (!v) { toast(S.soldOut); return; }
      if (!v.a) { toast(S.soldOut); return; }
      el.classList.add("is-loading");
      const name = ($(".ttl", card) || {}).textContent + " · " + size;
      addToCart(v.i, 1, name, true).finally(() => { el.classList.remove("is-loading"); card.classList.remove("is-qa"); });
      return;
    }
    if ((el = t.closest("[data-quickadd]"))) { el.classList.add("is-loading"); addToCart(Number(el.dataset.quickadd), 1, el.dataset.label).finally(() => el.classList.remove("is-loading")); return; }
    if ((el = t.closest("[data-wish]"))) { const on = el.getAttribute("aria-pressed") === "true"; el.setAttribute("aria-pressed", String(!on)); toast(on ? "Removed from wishlist" : "Saved to wishlist"); return; }

    if ((el = t.closest("[data-inc]"))) { changeLine(el.dataset.inc, Number(el.dataset.q) + 1); return; }
    if ((el = t.closest("[data-dec]"))) { changeLine(el.dataset.dec, Number(el.dataset.q) - 1); return; }
    if ((el = t.closest("[data-rm]"))) { changeLine(el.dataset.rm, 0); return; }

    /* cart page +/- : change then reload so Liquid totals stay truthful */
    if ((el = t.closest("[data-cart-inc],[data-cart-dec]"))) {
      const key = el.dataset.cartInc || el.dataset.cartDec, input = $(`[data-cart-qty="${key}"]`);
      const q = Math.max(0, Number(input.value) + (el.dataset.cartInc ? 1 : -1));
      input.value = q; el.closest("form, .cart-line, tr, article")?.classList.add("is-updating");
      jsonFetch(C.routes.cartChange + ".js", { method: "POST", body: JSON.stringify({ id: key, quantity: q }) }).then(() => location.reload()).catch(err => toast(err.message));
    }
  });

  /* ---------------------------------------------------------- boot */
  /* the pinned nav sits right under the announcement bar, whatever its height */
  function measureAnn() {
    const a = $("#shopify-section-announcement-bar");
    document.documentElement.style.setProperty("--ann-h", (a ? a.offsetHeight : 0) + "px");
  }
  window.addEventListener("resize", measureAnn, { passive: true });

  /* ------------------------------------------------- sign-up offer */
  function initSignupPop() {
    const pop = $("#signupPop"); if (!pop || pop._init) return; pop._init = true;
    const KEY = "yoya_signup_pop";
    const get = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
    const set = (v) => { try { localStorage.setItem(KEY, v); } catch (e) {} };
    const done = $("[data-pop-done]", pop), err = $("[data-pop-error]", pop);
    let timer = 0;
    const onScroll = () => { if (window.scrollY > window.innerHeight * 1.2) open(); };
    function open() {
      clearTimeout(timer); window.removeEventListener("scroll", onScroll);
      if (!pop.hidden) return;
      const d = $("#cartDrawer"), m = $("#mnav");
      if ((d && !d.hidden) || (m && !m.hidden)) { timer = setTimeout(open, 4000); return; } /* never on top of the bag or menu */
      openLayer(pop, (e) => { if (e.key === "Escape") close(); trap(pop, e); });
      const em = $("#popEmail", pop) || $("[data-pop-signup]", pop); if (em) em.focus({ preventScroll: true });
    }
    function close() {
      if (pop.hidden) return;
      if (!done) set("dismissed:" + Date.now());
      closeLayer(pop);
    }
    pop.addEventListener("click", (e) => {
      if (e.target === pop || e.target.closest("[data-pop-close]")) { close(); return; }
      if (e.target.closest("[data-pop-signup]")) { set("dismissed:" + Date.now()); return; }
      const c = e.target.closest("[data-pop-copy]");
      if (c && navigator.clipboard) navigator.clipboard.writeText(c.dataset.popCopy).then(() => { const s = $("[data-pop-copied]", c); if (s) s.textContent = "Copied"; }).catch(() => {});
    });
    const f = $("#popForm", pop);
    if (f) f.addEventListener("submit", () => { try { sessionStorage.setItem("yoya_pop_sent", "1"); } catch (e) {} });
    let sent = false; try { sent = sessionStorage.getItem("yoya_pop_sent") === "1"; sessionStorage.removeItem("yoya_pop_sent"); } catch (e) {}
    /* signed in with no orders yet: show the code once, straight away */
    const member = done && done.dataset.popMember;
    if (member) {
      const k = "yoya_welcome_" + member; let seen = false;
      try { seen = localStorage.getItem(k) === "1"; localStorage.setItem(k, "1"); } catch (e) {}
      set("done"); if (!seen) setTimeout(open, 500); return;
    }
    /* back from signing up: show the code (only when it was this form that was sent) */
    if (done) { set("done"); if (sent) open(); return; }
    if (err && sent) { open(); return; }
    const v = get() || "";
    if (v === "done") return;
    if (v.indexOf("dismissed:") === 0 && Date.now() - Number(v.slice(10)) < 14 * 864e5) return;
    timer = setTimeout(open, (Number(pop.dataset.delay) || 8) * 1000);
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function boot() { measureAnn(); initAnnouncement(); initPDP(); initSticky(); initAddress(); loadCart(); initSwatchWarmup(); initSignupPop(); if (location.hash === "#reviews") openReviews(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", () => { measureAnn(); initAnnouncement(); initPDP(); initSticky(); initAddress(); paintCart(); initSwatchWarmup(); });

  window.Yoya = { openDrawer, toast, money, addToCart, loadCart };
})();
